import { LANGUAGE_DE } from "../i18n/languageCodes";

export const searchTranslations = {
  de: { search: "Suche", placeholder: "Seiten und Daten suchen …", pages: "Seiten", empty: "Keine Ergebnisse.", error: "Fehler beim Laden der Suchergebnisse", retry: "erneut versuchen", loading: "Suche läuft …", pin: "anheften", unpin: "Anheftung entfernen", ask: "Qeddy fragen" },
  en: { search: "Search", placeholder: "Search pages and data …", pages: "Pages", empty: "No results.", error: "Error loading search results", retry: "Try again", loading: "Searching …", pin: "Pin", unpin: "Remove pin", ask: "Ask Qeddy" }
};
export type SearchLabels = typeof searchTranslations.en;

export function searchShortcutHint(language: string, platform = typeof navigator === "undefined" ? "" : navigator.platform): string {
  return /mac/i.test(platform) ? "⌘K" : language === LANGUAGE_DE ? "Strg+K" : "Ctrl+K";
}
